<template>
  <div class="layout-form">
    <error-reveal :error="uierror"></error-reveal>

    <div class="row expanded" v-show="!queryEnabled && refreshEnabled">
      <div class="small-12 medium-6 columns">
        <label>Utolsó beolvasás:</label>
        <div class="displayfield">{{analyticsReadingInf}}</div>
      </div>
    </div>
    <div class="row expanded" v-show="!queryEnabled && refreshEnabled">
      <div class="small-4 columns end">
        <button type="button" class="button primary trans-uppercase" @click="refresh">Frissítés</button>
      </div>
    </div>

    <joi-form :data="data" :schema="validationSchema" :error="formError" v-on:formdataready="save" v-show="queryEnabled">
      <div class="row">
        <div class="small-12 medium-6 columns small-centered">
          <span data-form-error-callout></span>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-8 medium-6 columns">
          <label>Utolsó beolvasás:</label>
          <div class="displayfield">{{analyticsReadingInf}}</div>
        </div>
        <div class="small-4 medium-6 columns text-right">
          <button type="button" class="button primary trans-uppercase" @click="refresh">Frissítés</button>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-12 medium-6 columns">
          <label error-path="channels">
            Oldalak:
          </label>
          <channel-cards
            v-model="data.channels"
            :channels="availableChannels"
          ></channel-cards>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Poszt típusok:
          </label>
          <input id="post-type-status" type="checkbox" value="status" v-model="data.types"><label for="post-type-status">Státusz</label>
          <input id="post-type-link" type="checkbox" value="link" v-model="data.types"><label for="post-type-link">Link</label>
          <input id="post-type-photo" type="checkbox" value="photo" v-model="data.types"><label for="post-type-photo">Kép</label>
          <input id="post-type-video" type="checkbox" value="video" v-model="data.types"><label for="post-type-video">Videó</label>
          <span error-path="types"></span>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-6 columns">
          <label>
            Vizsgált időszak:
            <date-picker v-model="data.interval" mode="range" error-path="interval"></date-picker>
            <span error-path="interval.min"></span>
            <span error-path="interval.max"></span>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-6 columns">
          <label>
            A domain tartalmazza:
            <textarea v-model="data.host"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-6 columns">
          <label>
            Az URL tartalmazza:
            <textarea v-model="data.link"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded bottom">
        <div class="small-4 columns">
          <button type="submit" class="button primary trans-uppercase">Lekérdezés</button>
        </div>
      </div>
    </joi-form>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import moment from 'moment'
import * as mutationTypes from '../../store/mutation-types'
import JoiForm from '../../inputs/joi-form'
import ChannelCards from '../../inputs/channel-cards'
import DatePicker from '../../inputs/date-picker'
import ErrorReveal from '../../errors/Reveal'
import {queryInsightsData as validationSchema} from '../../../schemas'
import insightsService from '../../services/insights'
import i18nService from '../../services/i18n'
import Confirm from '../../mixins/Confirm'
import $ from 'jquery'
import autosize from 'autosize'
import acl from '../../services/acl'
import CONST from '../../../constants'

export default {
  name: 'insights-query',
  mixins: [Confirm],
  components: {
    JoiForm,
    ChannelCards,
    DatePicker,
    ErrorReveal
  },
  data () {
    return {
      data: {
        channels: [],
        types: ['status', 'link', 'photo', 'video'],
        interval: {
          min: moment().subtract(1 + 30, 'days').toDate(),
          max: moment().subtract(1, 'days').toDate()
        },
        host: undefined,
        link: undefined
      },
      validationSchema,
      formError: null,
      existingUser: false,
      settings: null,
      queryEnabled: false,
      refreshEnabled: false,
      uierror: null,
      queryParams: null,
      analyticsReadingInf: null,
      availableChannels: []
      // service: insightsService.listTrackedChannels.bind(insightsService)
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created: function () {
    this.load()
    this.queryParams = this.$route.query
  },
  mounted: function () {
    if (acl.hasRole(this.user, CONST.ROLE.ADMIN)) {
      this[mutationTypes.SET_HEADER_ACTIONS]([{
        routerLinkTo: '/insights/settings',
        html: '<i class="fi-wrench"></i> Beállítások'
      }, {
        routerLinkTo: '/insights/share',
        html: '<i class="fi-share"></i> Megosztás'
      }])
    }

    autosize($('textarea', this.$el))
  },
  beforeDestroy: function () {
    this[mutationTypes.SET_HEADER_ACTIONS]([])
  },
  watch: {
    '$route': function (newVal, oldVal) {
      if (newVal.params.id) {
        this.load(newVal.params.id)
      }
    }
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF, mutationTypes.SET_HEADER_ACTIONS]),
    loadSettings () {
      if (acl.hasRole(this.user, CONST.ROLE.ADMIN)) {
        return insightsService.loadSettings()
      }

      return insightsService.loadSharedSettings()
    },
    load () {
      this.reset()
      this[mutationTypes.BUSY_ON]()
      this.loadSettings().then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.settings = data
        this.queryEnabled = false
        this.refreshEnabled = false
        this.availableChannels = data ? data.channels : []
        this.analyticsReadingInf = '-'

        if (this.queryParams.host) {
          this.data.host = this.queryParams.host
        }
        if (this.queryParams.link) {
          this.data.link = this.queryParams.link
        }
        if (this.queryParams.types) {
          this.data.types = this.queryParams.types
        }
        if (this.queryParams.from && this.queryParams.to) {
          this.data.interval = {
            min: this.queryParams.from,
            max: this.queryParams.to
          }
        }
        if (this.queryParams.channels) {
          this.loadChannels(this.queryParams.channels)
        }

        if (data && data.analytics && data.analytics.state === 'completed') {
          this.queryEnabled = true
          this.analyticsReadingInf = i18nService.interval(data.analytics.readStartedAt, data.analytics.readEndedAt)
          this.refreshEnabled = true
        } else {
          this.uierror = new Error('Nincs rendelkezésre álló adat, lekérdezés nem indítható.')
          if (data && data.analytics) {
            this.analyticsReadingInf = i18nService.interval(data.analytics.readStartedAt, data.analytics.readEndedAt)
            if (data.analytics.state !== 'reading' && acl.hasRole(this.user, CONST.ROLE.ADMIN)) {
              this.refreshEnabled = true
            }
          }
        }

        window.setTimeout(() => {
          autosize.update($('textarea', this.$el))
        }, 0)
      })
      .catch((e) => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    loadChannels (ids) {
      this[mutationTypes.BUSY_ON]()
      insightsService.loadChannels(ids).then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.data.channels = data
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    reset () {
    },
    save (formData) {
      var query = {}
      query.from = moment(this.data.interval.min).startOf('day').format()
      query.to = moment(this.data.interval.max).endOf('day').format()
      query.types = this.data.types
      query.channels = this.data.channels.map((channel) => channel.id)
      query.host = this.data.host
      query.link = this.data.link
      this.$router.push({name: 'insights-display', query: query})
    },
    refresh () {
      this[mutationTypes.BUSY_ON]()
      insightsService.refresh().then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.load()
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
        this.uierror = new Error('Kimutatás nem frissíthető.')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/form';
</style>



// WEBPACK FOOTER //
// Query.vue?33dd9c10